<template>
  <div class="container">
    <div class="row">
      <div class="col-12 offset-lg-2 col-lg-8">
        <page-content :orders="orders" @toggleShowDetail="toggleShowDetail"></page-content>
      </div>
    </div>
  </div>
</template>

<script>
  /* util */
  import {dd,store,app} from 'systems/imports'
  /* ui */
  import PageContent from 'page/partials/MyPage/Order/History/PageContent.vue'

  /** @see page_subPages_MyPage_Order parent page */
  /** @name page_subPages_MyPage_Order_History */
  export default {
    name:"",
    components: {
      PageContent,
    },
    props:["orders"],
    data () {
      return {
      }
    },
    created(){
    },
    methods:{
      toggleShowDetail(order){
          this.$emit("toggleShowDetail",order)
      }
    }
  }
</script>


<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// History.vue?7e6c5807